import "../css/WishHistory.css";

export default function WishHistory({ wishHistory, getColor, title, emptyCopy, lastResult, wasTargetHit }) {
    if (!wishHistory?.length) {
        return (
            <div className="history-empty-box">
                <div className="history-empty-title">{title}</div>
                <div className="history-empty-copy">{emptyCopy}</div>
            </div>
        );
    }

    const history = [...wishHistory].reverse();

    return (
        <div className="history-box">
            <div className="history-title">
                <span>{title}</span>
            </div>
            <div className="history-summary">
                {wasTargetHit && lastResult
                    ? `刚刚命中定轨：${lastResult.name}，这一抽很有宿命感。`
                    : lastResult
                        ? `最近一次结果是 ${lastResult.name}，故事还在继续。`
                        : `最近已经抽了 ${wishHistory.length} 次，故事还在继续。`}
            </div>
            <div className="history-list">
                <div className="history-foods">
                    {history.map((item, index) => (
                        <div
                            className={`history-item ${index === 0 ? 'history-item-latest' : ''}`}
                            key={`${item.id}-${index}`}
                        >
                            <img src={item.image} className="showWishPicture" alt={item.name} />
                            <div className="li-food-text" style={{ color: getColor(item.star) }}>{item.name}</div>
                            <div className="history-stars" style={{ color: getColor(item.star) }}>
                                {Array.from({ length: item.star }).map((_, starIndex) => (
                                    <span key={starIndex}>★</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
